<div class="modal-header">
  <h5 class="modal-title mb-0">{{ 'sunTimesYearlyTitle' | translate }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <app-anc-suntimes-yearly [serial]="serial"></app-anc-suntimes-yearly>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="close()">
    {{ 'close' | translate }}
  </button>
</div>
